"use strict";

// tweaks these below variable if you want to show subtotal and discount
var showCartSubTotalDiscountSection = true;
var showEmptyCartIcon = false;
var showCartCountInTopNav = true;
var showProgressBar = true;
var showVendorOnCartPage = false; // Fixed variables

var lineItemComparePrice;
var cartObject;
var cartCountEmptyValue = "0";
var boxID = "BuilderID";
var cartExtraInfo; //extra classes for the elements

var removeExtraClass = "btn-border-black-animate"; // recharge 2020

var frequency = "";
var recurringchecked = false;
var frequency_unit = ""; //SVG icons

var removeMiniCartTextOrIcon = ' <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15px" height="15px" viewBox="0 0 15 15" version="1.1"><title>10ECA23C-4A55-4792-BECB-81343F1ADE1D</title><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="WD_mini-cart_desktop" transform="translate(-1396.000000, -115.000000)"><g id="Group-3" transform="translate(1021.000000, 115.000000)"><g id="icon/UI/remove-X" transform="translate(375.000000, 0.000000)"><circle id="Oval" fill="#9EA29F" cx="7.5" cy="7.5" r="7.5"/><g id="Group" transform="translate(7.500000, 7.500000) rotate(45.000000) translate(-7.500000, -7.500000) translate(3.000000, 3.000000)" stroke="#FFFFFF" stroke-width="2"><line x1="4.5" y1="0" x2="4.5" y2="9" id="Path-7-Copy"/><line x1="0" y1="4.5" x2="9" y2="4.5" id="Path-7-Copy-2"/></g></g></g></g></g></svg>';
var minusIcon = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15px" height="15px" viewBox="0 0 15 15" version="1.1"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="WD_cart-account_Cart-Page" transform="translate(-700.000000, -348.000000)" stroke="#111" stroke-width="2"><g id="Group-2" transform="translate(160.000000, 326.000000)"><g id="Group" transform="translate(520.000000, 9.000000)"><g id="icon/UI/accordion-small-minus-white" transform="translate(20.000000, 13.000000)"><line x1="0" y1="7.5" x2="15" y2="7.5" id="Path-3"/></g></g></g></g></g></svg> ';
var plusIcon = ' <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15px" height="15px" viewBox="0 0 15 15" version="1.1"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="WD_cart-account_Cart-Page" transform="translate(-765.000000, -348.000000)" stroke="#111" stroke-width="2"><g id="Group-2" transform="translate(160.000000, 326.000000)"><g id="Group" transform="translate(520.000000, 9.000000)"><g id="icon/UI/accordion-small-plus-white" transform="translate(85.000000, 13.000000)"><line x1="0" y1="7.5" x2="15" y2="7.5" id="Path-3"/><line x1="1.83671553e-14" y1="7.5" x2="15" y2="7.5" id="Path-3-Copy" transform="translate(7.500000, 7.500000) rotate(90.000000) translate(-7.500000, -7.500000) "/></g></g></g></g></g></svg>';
$(document).ready(function ($) {
  reloadAjaxCartItemUsingCartAjaxObject();
  progressBar();
  quickCartTotal(); //	window.location.href = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=XXX.myshopify.com";
  //window.location = '/checkout';
});
/*
EVENTS
1. Update quantity
2. remove item from cart
3. reload ajax cart
4. quickCartTotal
5. cart.requestComplete
*/
//QUANTITY UPDATE

function updateCartQuantity(cartThis) {
  var id = $(cartThis).attr("data-variant-id");
  var quantity = $("#updates_" + id).val();
  var type = $(cartThis).attr("date-type");
  var newQuantity = parseInt(quantity);

  if (type == "plus") {
    newQuantity = newQuantity + 1;
  } else {
    if (newQuantity > 0) {
      newQuantity = newQuantity - 1;
    }
  }

  var formData = {
    updates: {}
  };
  formData.updates[id] = newQuantity; // Perform the AJAX request to update the cart

  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: formData,
    dataType: "json",
    success: function success(cart) {
      // Perform any additional tasks after removing items
      $("#updates_" + id).val(newQuantity);
      getCartData(cart);
    },
    error: function error(_error) {
      // Handle error if the request fails
      console.error("Error updating items from the cart:", _error);
    }
  });
}
/* If you need extra information like collection title, metafield etc then use this function */


function reloadAjaxCartItemUsingCartAjaxObject(data) {
  //   cartInfo(data);
  $.ajax({
    type: "GET",
    url: "/cart?view=alternate.json",
    success: function success(response) {
      //extra information against the cart like collection title metafield, product title metafield, tags
      cartExtraInfo = $.parseJSON(response);
      cartInfo(data);
    },
    error: function error(status) {
      console.warn("ERROR", status);
      cartInfo(data);
    }
  });
} //RELOAD AJAX CART


function cartInfo(data) {
  var lineCount = 1;
  var cartObject;

  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
    quickCartTotal(data);
  }

  $(".js__ajax-products-bind").html("");
  $(".cart-list").html("");

  if (cartObject.items.length == 0) {
    $(".empty-cart-section").show();
    $(".js__show-cart-items-section").hide();
    $(".js__ajax-products-bind").html('<li class="empty-mini-cart"><div class="width-100"> <p class="">Your cart is empty</p> </div></li>');
    $(".freq-product-list").hide();
    $(".free-shipping").hide();
    $(".js__ajax-cart-count").html(cartCountEmptyValue);
    $(".js__ajax-cart-total").hide();
    $(".js__top-cart-form-actions").hide();
    $(".js__show-cart-items-section").hide();
    $(".js__cart-expand ").addClass("empty-cart");
  } else {
    $(".freq-product-list").show();
    $(".free-shipping").show();
    $(".js__ajax-cart-count").html(cartObject.item_count);
    $(".js__ajax-cart-total").show();
    $(".js__top-cart-form-actions").show();
    $(".js__show-cart-items-section").show();
    $(cartObject.items).each(function () {
      var imageURL = this.featured_image.url; //imageURL = imageURL[0] + "." + imageURL[1] + '_450x450' + "." + imageURL[2];

      var imageAlt = this.featured_image.alt;
      var itemPrice = this.original_price;
      var itemLinePriceTotal = this.line_price;
      var handle = this.handle;
      var itemID = this.id;
      var itemPriceAfterDiscount = this.discounted_price;
      var comparePrice = "";
      var disabled = "";
      var finalLineItemPrice = this.final_line_price;
      var cartBundleBoxID = "";
      var boolPromoOffer = false;
      var productTitle = this.product_title;
      var url = this.url;
      var itemProperties = "";
      var itemPropertiesElement = "";
      var boolItemBoxType = false;
      var hideElementClass = "";
      var readonly = "";
      var justifyCenter = "";
      var sellingPlayInformation = "";

      if (this.selling_plan_allocation != undefined) {
        sellingPlayInformation = this.selling_plan_allocation.selling_plan.name;
      }

      if (this.properties != null) {
        itemProperties = this.properties;

        if (Object.keys(itemProperties).length > 0) {
          $.each(itemProperties, function (key, value) {
            /* If box ID exists, then remove quantity + -  working */
            if (key == boxID) {
              cartBundleBoxID = value;
            }

            if (key == "_ProductUrl") {
              url = value;
            }

            if (key == "_promoOffer") {
              boolPromoOffer = true;
            }
          });
          /* Checking the Box ID for the builder */

          itemPropertiesElement = "<ul>";
          $.each(itemProperties, function (key, value) {
            /* If box ID exists, then remove quantity + -  working */
            if (key == boxID) {
              hideElementClass = "hide";
              readonly = "readonly='readonly'";
              boolItemBoxType = true;
              justifyCenter = "justify-center ";
              url = "javascript:;";
            }

            if (key.indexOf("_") > -1) {} else {
              if (key != boxID) {
                itemPropertiesElement += "<li class='flex'><span>" + key + ": </span><span style='padding-left: 5px'>" + value + "</span>";
                itemPropertiesElement += "</li>";
              } else {
                itemPropertiesElement += "<li class='flex'><span>" + key + ": </span><span style='padding-left: 5px'>" + value + "</span>";
                itemPropertiesElement += "</li>";
              }
            } // Recharge - when subscription is via properties for older recharge version before November 2020


            recharge2020(key, value);
          }); // Recharge 2020, check if it's a subscription, then bind the value in the UL

          if (recurringchecked) {
            itemPropertiesElement += "<li class='flex'><span>Recurring Delivery every " + frequency + " " + frequency_unit + ". Change or cancel anytime</span>";
            itemPropertiesElement += "</li>";
          }

          itemPropertiesElement += "</ul>";
        } else {//itemPropertiesElement = "";
        }
      }
      /* Loop through cartExtraInformation section */


      $(cartExtraInfo.items).each(function (key, value) {
        if (value.id == itemID) {
          if (value.comparePrice != null) {
            comparePrice = value.comparePrice;
          }

          productTitle = "<h5> <a href='" + url + "' id='product-card-" + this.id + "' tabindex='0'>" + value.product_title.split("with")[0] + " </a></h5>";
        }
      });
      /* get compare price using cartLib object */
      // if (typeof cartLib !== "undefined") {
      //           $.each(cartLib, function(key, value) {
      //               //console.log(value);
      //               if (value["id"] == itemID) {
      //                   comparePrice = value["comparePrice"];
      //               }
      //           });
      //       }

      /* FORMATTED PRICING */

      var formattedcomparePrice = formatter.format(comparePrice / 100);
      var comparePriceHtml = "";

      if (comparePrice > parseFloat(itemPrice)) {
        comparePriceHtml = "<s>" + formattedcomparePrice + "</s>";
      } // total compared price for the item with quantity


      var totalListItemComparePrice = formatter.format(comparePrice * this.quantity / 100); // item original price

      var formattedItemPrice = formatter.format(itemPrice / 100); // line price

      var formattedItemLinePriceTotal = formatter.format(itemLinePriceTotal / 100); //final line item price

      var formattedFinalLineItemPrice = formatter.format(finalLineItemPrice / 100); //Price after discount

      var showPrice = "";
      var itemPriceAfterDiscountStatus = false;
      var discountedMessage = "";
      var discountedMessageElement = "";

      if (this.discounts != null) {
        discountedMessage = this.discounts;

        if (Object.keys(discountedMessage).length > 0) {
          //console.log("DISCOUNT EXISTS");
          discountedMessageElement = "<span class='discountedMessage'>";
          $.each(discountedMessage, function (key, value) {
            discountedMessageElement += value.title;
          });
          discountedMessageElement += "</span>";
        }
      }

      var formattedItemPriceAfterDiscount = formatter.format(itemPriceAfterDiscount / 100); // if itemPriceAfterDiscount > 0 then set the status to true so you can interchange the values

      if (this.discounts.length > 0) {
        itemPriceAfterDiscountStatus = true;
      } // if it's true; then show the compared price as the main price this.price and main price as discounted price


      if (itemPriceAfterDiscountStatus) {
        //comparePriceHtml
        showPrice = '<span class="price-wrapper js__raw-line-item-price"  data-attr-compare-price="0"><s>' + formattedItemPrice + '</s><span class="price" data-key="' + itemID + '">' + formattedItemPriceAfterDiscount + "</span><span class='forMiniCart'>" + formattedFinalLineItemPrice + "</span></span>" + discountedMessageElement;
      } else {
        showPrice = '<span class="price-wrapper js__raw-line-item-price"  data-attr-compare-price="0">' + comparePriceHtml + '<span class="price" data-key="' + itemID + '">' + formattedItemPrice + "</span><span class='forMiniCart'>" + formattedFinalLineItemPrice + "</span></span>";
      }
      /* check if variantTitle is NULL, then don't show variant */


      var variantTitle = this.variant_title;

      if (variantTitle == null) {
        variantTitle = "";
      }

      var variantData = "";
      $.each(this.options_with_values, function (key, value) {
        //console.log("key" + key);console.log("value" + value["name"]);console.log("value" + value["value"]);
        variantData += "<li><span>" + value["name"] + ": " + value["value"].split("with")[0] + "</span></li>";
      });
      /* CUSTOM - if the product title contains "bag",  then disabled the quantity element
          To be applied for all the products with BoxID and Promo Offer
          */

      if (this.product_title.toLowerCase().indexOf("bag") >= 0 && cartBundleBoxID != "" || this.product_title.toLowerCase().indexOf("bag") >= 0 && boolPromoOffer) {
        //if you want to hide the quantity + - then enable the class below
        // hideElementClass="hide"
        justifyCenter = "justify-center ";
        readonly = "readonly='readonly'";
        disabled = "disabled ";
      }
      /* 
      LINE ITEM FOR THE MINI CART
      */
      // remove anchor


      var removeAnchorElement = '<div class="remove js__cart-item-remove ' + removeExtraClass + '" data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '"  data-cart-remove-variant="' + this.id + ">" + removeMiniCartTextOrIcon + "</div>"; //quantity element

      var quantityElement = '<div class="cart-quantity-outer ' + disabled + justifyCenter + '"> <a  tabindex="0"  class="minus-qty ' + hideElementClass + '  font-zero" date-type="minus" onclick="updateCartQuantity(this)"   data-variant-id="' + itemID + '">' + minusIcon + '</a> <input aria-label="Quantity"  tabindex="-1"  data-limit="' + boolItemBoxType + '"  ' + readonly + '   onkeydown="return isNumeric(event);" type="text"  data-attr-raw-variant-quantity="94" data-cart-line-count="' + lineCount + '" class="cart__quantity-selector js__cart__quantity-selector" name="updates[]" id="updates_' + itemID + '" value="' + this.quantity + '" maxlength="3" size="3"> <a  tabindex="0"  class="plus-qty ' + hideElementClass + '  font-zero" date-type="plus" onclick="updateCartQuantity(this)"     data-variant-id="' + itemID + '">' + plusIcon + "</a> </div>"; //vendor element

      var vendorElement = '<span class="subheading uppercase">' + this.vendor + "</span>";
      var lineItem;
      lineItem = '<li class="flex-wrap js__cart-table-item-row" data-cart-line-count=' + lineCount + ' data-handle="' + handle + '" data-variant-id=' + itemID + '><div class="image-section"> <a href="' + url + '"><img alt="' + imageAlt + '" src="' + imageURL + '""> </a> </div>';
      lineItem += '<div class="content"><div class="title-section">' + productTitle + removeAnchorElement + "";

      if (sellingPlayInformation != "") {
        lineItem += '<p class="capitalize">' + sellingPlayInformation + "</p>";
      }

      if (itemPropertiesElement != "") {
        lineItem += '<p class="capitalize">' + itemPropertiesElement + "</p>";
      }

      if (variantTitle != "") {
        lineItem += "<ul>" + variantData + "</ul>";
      }

      lineItem += showPrice + '</div><div class="flex-space-between"><p class="hide">Qty ' + this.quantity + "</p>" + quantityElement;
      lineItem += "<span class='price'>" + formattedItemPriceAfterDiscount + comparePriceHtml + "</span></div></div>";
      lineItem += "</li>";
      /* Bind the line item to the list */

      $(".js__ajax-products-bind").append(lineItem);
      /*******LINE ITEM FOR THE CART PAGE********/

      if ($(".cart-list")[0]) {
        var cartLineItem = "";
        cartLineItem = '<div class="cart-list__items cart-table-body js__cart-table-item-row flex" data-cart-line-count="' + lineCount + '" data-attr-compare-price="" data-variant-id="' + itemID + '"><div class="cart-list__items__columns"><div class="image-section "><img class="img-responsive img-thumbnail item-image" src="' + imageURL + '" alt="' + imageAlt + '"></div> <div class="content">'; // show vendor on cart page

        if (showVendorOnCartPage) {
          cartLineItem += vendorElement;
        }

        cartLineItem += productTitle;
        cartLineItem += '<div class="cart-list__variant-properties">';

        if (sellingPlayInformation != "") {
          cartLineItem += '<span class="capitalize">' + sellingPlayInformation + "</span>";
        }

        if (itemPropertiesElement != "") {
          cartLineItem += '<span class="capitalize">' + itemPropertiesElement + "</span>";
        }

        if (variantTitle != "") {
          cartLineItem += "<ul>" + variantData + "</ul>";
        }

        cartLineItem += "</div>";
        cartLineItem += '<a class="remove btn-border-small-black" data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '" href="javascript:;">remove</a>  </div>  </div>  <div class="cart-list__items__columns">';
        cartLineItem += showPrice;
        cartLineItem += "</div>";
        cartLineItem += '<div class="cart-list__items__columns quantity" data-variant-id="' + itemID + '"> ' + quantityElement + '  <span class="js__out-of-stock"></span>'; // ** Remove action is added here too

        cartLineItem += "</div>";
        cartLineItem += '<div class="cart-list__items__columns total-price " data-head="Total"> <span class="price-wrapper js__set-line-item-price" data-attr-price="' + itemPrice + '" data-attr-compare-price=' + totalListItemComparePrice + '><s class="hide">' + totalListItemComparePrice + '</s><span class="price" data-key="' + itemID + '">' + formattedItemLinePriceTotal + "</span> </span>"; // ** Remove element is added here too

        cartCountEmptyValue += " </div></div>";
        $(".cart-list").append(cartLineItem);
      }

      lineCount++;
    });
  }
} //CALCULATE TOTAL OF THE CART


function quickCartTotal(data) {
  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
  }

  var total = cartObject.items_subtotal_price;
  total = total / 100;
  total = formatter.format(total);
  $(".js__cart-total").html(total);
  $(".js__ajax-cart-total").html("" + total);
  $(".js__ajax-cart-total").show();
  $(".js__ajax-cart-count").html(cartObject.item_count);
  $(".js__top-cart-form-actions").show();
  $(".js__cart-expand ").removeClass("empty-cart");
}
/* REMOVE */


var savedItemPropertyBoxID = "";
$(document).on("click", ".remove", function () {
  var variantID = parseInt($(this).attr("data-variant-id"));
  var clickedLineItemCount = parseInt($(this).attr("data-cart-line-count"));
  var currentLoopItemCount = 1; // console.log(variantID);

  var boxID = "BuilderID";
  var itemsToRemove = [];
  var formData = {
    updates: {}
  };
  $.getJSON("/cart.js", function (cart) {
    var savedItemPropertyBoxID = ""; // console.log(cart.items.length);
    // Find the item with the matching variantID and save its BoxID property

    for (var i = 0; i < cart.items.length; i++) {
      if (clickedLineItemCount === currentLoopItemCount) {
        console.log("EUQAL");
        var currentItem = cart.items[i];

        if (currentItem.variant_id === variantID) {
          // console.log(currentItem);
          // console.log(currentItem.variant_id);
          // console.log("variant ID matches");
          // console.log(currentItem.properties);
          // console.log(currentItem.properties[boxID]);
          if (currentItem.properties && currentItem.properties[boxID]) {
            savedItemPropertyBoxID = currentItem.properties[boxID]; // console.log("Saved Item Property Box ID:", savedItemPropertyBoxID);

            break;
          } else {
            // it doesn't has the BoxID, then delete the particular LineItem
            // console.log("Current Line Item - With no BoxID")
            itemsToRemove.push(currentItem.variant_id);
          }
        }
      }

      currentLoopItemCount = currentLoopItemCount + 1;
    } // Loop through cart items to find items with matching BoxID


    for (var j = 0; j < cart.items.length; j++) {
      var currentItem = cart.items[j];

      if (currentItem.properties && currentItem.properties[boxID] === savedItemPropertyBoxID) {
        itemsToRemove.push(currentItem.variant_id); //console.log("Item Variant ID to Remove:", currentItem.variant_id);
      }
    } // console.log(itemsToRemove);
    // console.log(itemsToRemove.length);
    // Call the function to remove items from the cart


    removeItemsFromCart(itemsToRemove); // Remove items from the cart
  });
}); // Function to remove items from the cart

function removeItemsFromCart(itemsToRemove) {
  var formData = {
    updates: {}
  }; // Populate the formData with variant IDs to remove

  for (var k = 0; k < itemsToRemove.length; k++) {
    var variantID = itemsToRemove[k];
    formData.updates[variantID] = 0;
  }

  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: formData,
    dataType: "json",
    success: function success(cart) {
      getCartData(cart);
    },
    error: function error(_error2) {
      // Handle error if the request fails
      console.error("Error removing items from the cart:", _error2);
    }
  });
}

function getCartData() {
  $.getJSON("/cart.js", function (cart) {
    cartInfo(cart);
    progressBar();
    setTimeout(function () {
      addons();
    }, 1000);
  });
}
/*
PROGRESS BAR
*/


function progressBar() {
  var totalAmount = 0;

  if (showProgressBar) {
    fetch("/cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }).then(function (res) {
      return res.json();
    }).then(function (data) {
      totalAmount = data.total_price / 100;
      var freeShippingAmount = parseFloat($(".js__free-shipping-limit").html());
      var freeShippingRemaningAmount = freeShippingAmount - totalAmount;
      var freeShippingPercentage = 100;

      if (freeShippingRemaningAmount > 0) {
        freeShippingPercentage = totalAmount * 100 / freeShippingAmount;
        $(".js__free-shipping-limit-message").show();
        $(".js__free-shipping-message").hide();
        $(".js__free-shipping").hide();
        $(".js__CartShipping").addClass("hide");
      } else {
        $(".js__CartShipping").removeClass("hide");
        $(".js__free-shipping-limit-message").hide();
        $(".js__free-shipping-message").show();
        $(".js__free-shipping").show();
      }

      $(".js__free-shipping-remaning-amount").html(formatter.format(freeShippingRemaningAmount));
      $(".js__free-shipping__progress-bar").attr("data-percentage", freeShippingPercentage);
      $(".js__free-shipping__progress-bar").children("span").css("width", freeShippingPercentage + "%");
    });
  }
}

$(document).ready(function ($) {
  $(".js__addon-add-to-cart").click(function () {
    var quantity = 1;
    var addonSelectedVariantID = $(this).attr("data-attr-variantid");
    cartAddItemAddon(addonSelectedVariantID, quantity);
  });
  $(".js__addon-add-to-cart").keypress(function () {
    var keycode = event.keyCode || event.which;

    if (keycode == "13") {
      event.preventDefault();
      var quantity = 1;
      var addonSelectedVariantID = $(this).attr("data-attr-variantid");
      cartAddItemAddon(addonSelectedVariantID, quantity);
    }
  });
});
/*
ADDONS
NOTE:: CONFUSING CODE FOR THE ADDONS - WILL NEED TO CLEAN IT A BIT
1. Try to get all the addon handles for the items which are in the cart
2. Create an array for item>addon
3. Loop through all the cart items and addon
4. CHECK - if addon is already there in the list, then the same 2nd addon should not be visible
*/

function cartAddItemAddon(addonSelectedVariantID, addonQuantity) {
  CartJS.addItem(addonSelectedVariantID, addonQuantity, {}, {
    success: function success(data, textStatus, jqXHR) {//console.log("success");

      /* Pending - Remove the selected addon when add to cart is clicked */
    },
    error: function error(jqXHR, textStatus, errorThrown) {//console.log("error");
    }
  });
}

function addons() {
  //console.log("addons");

  /*Hide repeating addons*/
  var cartAddons = "";
  $(".js__top-cart-addons li").each(function (index) {
    // update this with variantID
    var addoneHandle = $(this).attr("data-handler"); // if cartAddon is null,

    if (cartAddons == "") {
      // save the addonHandle
      cartAddons = addoneHandle;
    } else {
      //set bool value to see if the addons is present in the addon list or not
      // by default it's false
      var boolCartAddons = false; // going through the string and checking if the current addon handle = the addon
      //handle present in the string

      var cartAddons2 = cartAddons.split(",");

      for (var a = 0; a < cartAddons2.length; a++) {
        if ($(this).attr("data-handler") == cartAddons2[a]) {
          // if present, then hide it
          $(this).hide();
          boolCartAddons = true;
        }
      } // add the new addon handle to the string


      if (boolCartAddons == false) {
        cartAddons = cartAddons + "," + addoneHandle;
      }
    }
    /* Hide the addons from the addon list, if the addon is present in the cart */


    var boolItemCartAddon = false;
    $(".js__ajax-products-bind li").each(function (index) {
      var itemHandle = $(this).attr("data-handle");

      if (addoneHandle == itemHandle) {
        boolItemCartAddon = true;
      }
    });

    if (boolItemCartAddon == true) {
      $(this).hide();
    } else {
      $(this).show();
    }
  });
  /* Hide the complete section if there are no addons */

  var boolAddonExist = false;
  $(".js__top-cart-addons li").each(function (index) {
    if ($(this).css("display") != "none") {
      boolAddonExist = true;
    }
  }); //console.log("boolAddonExist"+boolAddonExist);

  if (boolAddonExist == false) {
    //console.log("if");
    $(".js__freq-bought-products").hide();
  } else {
    //console.log("else");
    $(".js__freq-bought-products").show();
  }
} //Addons are fetched from the schemas; Varies from theme to theme


setTimeout(function () {
  addons();
}, 1000);

function recharge2020(key, value) {
  if (key == "shipping_interval_frequency") {
    frequency = value;
    recurringchecked = "true";
  }

  if (key == "shipping_interval_unit_type") {
    if (frequency == "1") {
      if (value == "Days") {
        frequency_unit = "Day";
      } else if (value == "Months") {
        frequency_unit = "Month";
      } else if (value == "Weeks") {
        frequency_unit = "Week";
      }
    } else {
      frequency_unit = value;
    }
  }
}
/*cart numeric type*/
// $(".js__cart__quantity-selector").keypress(function (event) {
//     var keycode = event.keyCode || event.which;
//     if (keycode == "13") {
//         event.preventDefault();
//         if ($(this).val() == "0") {
//             $(this).val("1");
//         }
//         var lineCount = $(this).attr("data-cart-line-count");
//         updateQuantity(lineCount);
//         return false;
//     }
// });
"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

jQuery(function () {
  var _Swiper, _Swiper2, _Swiper3;

  $(window).scroll(function () {
    // var targetScroll = $('.quantity-btn-wrapper').position().top;
    if ($('.quantity-btn-wrapper').html() != undefined) {
      var targetScroll = $('.quantity-btn-wrapper').offset().top - $('.quantity-btn-wrapper').outerHeight() + 20;

      if ($(window).scrollTop() > targetScroll) {
        $(".top-banner").addClass("active");
      } else {
        $(".top-banner").removeClass("active");
      }
    }
  });
  /* Hero Banner SLider */

  var heroSlider = new Swiper(".js__hero-banner-slider", {
    slidesPerView: 1,
    autoHeight: true,
    clickable: false,
    resistance: false,
    shortSwipes: false,
    grabCursor: false,
    threshold: 5,
    lazy: {
      loadPrevNext: true,
      // Preload next/prev slide images
      loadPrevNextAmount: 2 // Number of next/prev slides to preload

    },
    loop: true,
    spaceBetween: 0,
    autoplay: {
      delay: 10000
    },
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next-hero-banner",
      prevEl: ".swiper-button-prev-hero-banner"
    }
  });
  var quoteSlider = new Swiper(".js_quote-slider", (_Swiper = {
    slidesPerView: 1,
    autoHeight: true,
    resistance: false,
    threshold: 5,
    autoplay: {
      delay: 2000
    }
  }, _defineProperty(_Swiper, "threshold", 5), _defineProperty(_Swiper, "spaceBetween", 20), _defineProperty(_Swiper, "pagination", {
    el: '.slider___pagination',
    clickable: true,
    type: 'custom',

    /*Return bullets as numbers*/
    renderCustom: function renderCustom(swiper, current, total) {
      if (current > 9) {
        return '<span class="current">' + current + '</span>' + '/' + '<span class="total">' + total + '</span>';
      } else {
        if (total > 9) {
          return '<span class="current">' + 0 + current + '</span>' + '/' + '<span class="total">' + total + '</span>';
        }

        return '<span class="current">' + 0 + current + '</span>' + '/' + '<span class="total">' + 0 + total + '</span>';
      }
    }
  }), _defineProperty(_Swiper, "navigation", {
    nextEl: ".swiper-button-next-quote-slider",
    prevEl: ".swiper-button-prev-quote-slider"
  }), _Swiper));
  var productslider = new Swiper('.js__product-slider', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    resistance: false,
    shortSwipes: true,
    loop: false,
    threshold: 5,
    autoHeight: true,
    navigation: {
      nextEl: '.swiper-button-next-product-slider',
      prevEl: '.swiper-button-prev-product-slider'
    },
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        spaceBetween: 15
      },
      481: {
        slidesPerView: 'auto',
        spaceBetween: 20
      }
    }
  });
  var cardsliderpdp = new Swiper('.js__card-slider', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    resistance: false,
    shortSwipes: true,
    loop: true,
    threshold: 5,
    autoHeight: true,
    navigation: {
      nextEl: '.swiper-button-next-card-slider',
      prevEl: '.swiper-button-prev-card-slider'
    },
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        spaceBetween: 15
      },
      481: {
        slidesPerView: 'auto',
        spaceBetween: 20
      }
    }
  }); // logo Slider

  var sixColumnSlider = new Swiper('.js__six-column-logo-slider', (_Swiper2 = {
    slidesPerView: 6,
    spaceBetween: 60,
    freeMode: true,
    watchSlidesProgress: true,
    clickable: true,
    resistance: false,
    shortSwipes: false,
    loop: true,
    grabCursor: false,
    threshold: 5
  }, _defineProperty(_Swiper2, "threshold", 1), _defineProperty(_Swiper2, "speed", 5000), _defineProperty(_Swiper2, "autoplay", {
    delay: 1,
    disableOnInteraction: false
  }), _defineProperty(_Swiper2, "breakpoints", {
    0: {
      slidesPerView: 'auto',
      spaceBetween: 40
    },
    481: {
      slidesPerView: 3,
      spaceBetween: 40
    },
    769: {
      slidesPerView: 4,
      spaceBetween: 40
    },
    1025: {
      slidesPerView: 5,
      spaceBetween: 40
    },
    1201: {
      slidesPerView: 6,
      spaceBetween: 60
    }
  }), _Swiper2)); // Image Slider

  var imageContentSlider = new Swiper('.js__full-width-content-slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    threshold: 5,
    resistance: false,
    shortSwipes: true,
    loop: false,
    autoHeight: true,
    pagination: {
      el: '.image-slider__pagination',
      clickable: true,
      type: 'custom',
      renderCustom: function renderCustom(swiper, current, total) {
        // return (
        //   '<span class="current">' + 0 + current + '</span>' + '/' + '<span class="total">' + 0 + total + '</span>'
        // );
        if (current > 9) {
          return '<span class="current">' + current + '</span>' + '/' + '<span class="total">' + total + '</span>';
        } else {
          if (total > 9) {
            return '<span class="current">' + 0 + current + '</span>' + '/' + '<span class="total">' + total + '</span>';
          }

          return '<span class="current">' + 0 + current + '</span>' + '/' + '<span class="total">' + 0 + total + '</span>';
        }
      }
    },
    scrollbar: {
      el: '.swiper--scrollbar',
      hide: false,
      draggable: true
    },
    navigation: {
      nextEl: '.swiper-button-next-image-content-slider',
      prevEl: '.swiper-button-prev-image-content-slider'
    }
  }); //  cart recommended Products

  var cartProductSlider = new Swiper('.js__card-recommendation-slider', (_Swiper3 = {
    slidesPerView: 4,
    loop: true,
    allowTouchMove: true,
    shortSwipes: true,
    threshold: 5,
    spaceBetween: 0
  }, _defineProperty(_Swiper3, "threshold", 1), _defineProperty(_Swiper3, "navigation", {
    nextEl: '.swiper-button-next-cartproduct-slider',
    prevEl: '.swiper-button-prev-cartproduct-slider'
  }), _defineProperty(_Swiper3, "breakpoints", {
    0: {
      slidesPerView: 2
    },
    481: {
      slidesPerView: 3
    },
    601: {
      slidesPerView: 4
    },
    769: {
      slidesPerView: 4
    }
  }), _Swiper3));
  /* SLIDER */

  /* Collection selected*/

  $(document).ready(function ($) {
    $(".js__collections-select").change(function () {
      window.location = $(this).val();
    });
    /*Dropdown selected*/

    $(".js__collection-content li").each(function (index) {
      var value = $(this).attr("data-url").toLowerCase();

      if (window.location.href.toLowerCase().indexOf(value) > -1) {
        $(this).addClass("active");
        $(".js__collections-select").val($(this).attr("data-url"));
      }
    });
  });

  try {
    var pageTotal = parseInt($(".js__total-page").val());
    var currentPage = parseInt($(".js__current-page").val());
    var itemTotal = parseInt($(".js__items-count").val());
    var perPageItem = parseInt($(".js__perpage-item").val());
    var itemStart = 1;
    var itemEnd = 0;

    if (currentPage > 1) {
      itemStart = perPageItem * (currentPage - 1) + 1;
    }

    itemEnd = itemStart + perPageItem - 1;

    if (pageTotal == currentPage) {
      itemEnd = itemTotal;
    }

    $(".js__page-range").html(itemStart + " - " + itemEnd);
  } catch (_unused) {}
  /* PDP
  Tab working */


  $(".tab-link").on("click", function () {
    var dataId = $(this).attr("data-attr");
    var i, tabcontent, tablink;
    tabcontent = document.getElementsByClassName("tab-content");

    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    tablink = document.getElementsByClassName("tab-link");

    for (i = 0; i < tablink.length; i++) {
      tablink[i].className = tablink[i].className.replace(" active", "");
    }

    document.getElementById(dataId).style.display = "block";
    event.currentTarget.className += " active";
    /*PDP select*/

    $(".js__pdp-tab-select").val(dataId);
  });
  /* GLOBAL
  Scroll to particular Div with # value */

  $('a[href^="#"]').on("click", function (event) {
    var target = $(this.getAttribute("href"));

    if (target.length) {
      event.preventDefault();
      $(".tab-head").hide();
      $("html, body").stop().animate({
        scrollTop: target.offset().top - 150
      }, 1000);
    }
  });
  /* accordion working about content in small screen*/

  $("#scrollaccordian").on("click", function (event) {
    $(".js__accordian").children(".outer-list").first().addClass("active");
    $(".js__accordian").children(".outer-list").first().children(".content").slideDown();
  });
  $(".js__accordian").children("li").children("h2,h5,h6,h3").click(function (e) {
    if ($(this).parent("li").children(".content").css("display") == "none") {
      $(this).parent("li").parent(".js__accordian").children("li").children(".content").hide();
      $(this).parent("li").parent(".js__accordian").children("li").removeClass("active");
      $(this).parent("li").children(".content").slideDown();
      $(this).parent("li").addClass("active");
      /* $('html,body').animate({
        scrollTop: $(this).offset().top - 120
      }, 500);*/
    } else {
      $(this).parent("li").children(".content").slideUp();
      $(this).parent("li").removeClass("active");
    }
  });
  /* Accordion working when we have multiple content*/

  $(".js__accordians").children("li").attr("aria-expanded", false);
  $(".js__accordians").children("li").children("h5,h6,h3,h4").attr("role", "button");
  $(".js__accordians").children("li").children("h5,h6,h3,h4").attr("tabindex", "0");
  $(".js__accordians").children("li").children("h5,h6,h3,h4").click(function (e) {
    var type = $(this).parent("li").attr("data-attr");

    if ($("." + type).css("display") == "none") {
      $(this).attr("aria-expanded", true);
      $(this).parent("li").parent(".js__accordians").children(".content").hide();
      $(this).parent("li").parent(".js__accordians").children("li").removeClass("active");
      $("." + type).slideDown();
      $(this).parent("li").addClass("active");
      $(this).addClass("active");
    } else {
      $(this).attr("aria-expanded", false);
      $(this).parent("li").removeClass("active");
      $("." + type).slideUp();
      $(this).removeClass("active");
    }
  });
  $(".js__accordians").children("li").children("h5,h6,h3,h4").keypress(function (e) {
    if (e.which == 13) {
      var type = $(this).parent("li").attr("data-attr");

      if ($("." + type).css("display") == "none") {
        $(this).attr("aria-expanded", true);
        $(this).parent("li").parent(".js__accordians").children(".content").hide();
        $(this).parent("li").parent(".js__accordians").children("li").removeClass("active");
        $("." + type).slideDown();
        $(this).parent("li").addClass("active");
        $(this).addClass("active");
      } else {
        $(this).attr("aria-expanded", false);
        $(this).parent("li").removeClass("active");
        $("." + type).slideUp();
        $(this).removeClass("active");
      }
    }
  });
});
/** Dropdown **/

jQuery(function ($) {
  $(".js__dropdown_result").on("click", function () {
    if ($(".js__dropdown").css("display") == "none") {
      $(".js__dropdown").slideDown(300);
    } else {
      $(".js__dropdown").slideUp(300);
    }

    $(this).toggleClass("active");
  });
  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path

  $(".js__dropdown li a").each(function () {
    if (this.href === path) {
      $(this).addClass("active");
      console.log($(this).html());

      if ($(this).html() != "view all") {
        $(".js__dropdown_result").html($(this).html());
      }

      $(".js__dropdown").slideUp(300);
      $(".js__dropdown_result").removeClass("active");
    }
  });
  $(".js__active-class li a").each(function () {
    if (this.href === path) {
      $(".js__active-class li a").removeClass("active");
      $(this).addClass("active");
    }
  });
});
/* Mini cart - Checkout Button visiblity fix for IOS Mobile */

var lastScroll = 0;
jQuery(document).ready(function ($) {
  $(".cart-sidebar__middle").addClass("safari-mobile");
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll > lastScroll) {
      $(".cart-sidebar__middle").removeClass("safari-mobile");
    } else if (scroll < lastScroll) {
      $(".cart-sidebar__middle").addClass("safari-mobile");
    }

    lastScroll = scroll;
  });
});
/** Dropdown **/

jQuery(function ($) {
  /*Blog dropdown*/
  $(".js__blog-select").change(function () {
    window.location = $(this).val();
  });
  /*Dropdown selected*/

  $(".js__blog-select option").each(function (index) {
    var value = $(this).val().toLowerCase();

    if (window.location.href.toLowerCase().indexOf(value) > -1) {
      $(".js__blog-select").val($(this).val());
    }
  });
});
jQuery(function ($) {
  $(".js--open-rates-popup").on("click", function () {
    $(".js__rates-popup").show();
  });
  $(".js__modal-close").on("click", function () {
    $(".modal").hide();
  });
});
/*First tab link and first tab content active */

jQuery(document).ready(function ($) {
  $(".tab-link").first().addClass("active");
  $(".shopify-section .tab-content").first().show();
});
/*Select Dropdown change wit Tab */

jQuery(function () {
  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path

  $(".dropdown-select option").each(function () {
    if (this.value.toLowerCase() == path.toLowerCase()) {
      this.setAttribute("selected", true);
    }
  });
  $(".dropdown-select").change(function () {
    var dropdown = $(".dropdown-select").val(); //first hide all tabs again when a new option is selected

    $(".tab-content").hide(); //then show the tab content of whatever option value was selected

    $("#" + "tab-" + dropdown).show();
  });
});
/*Blog content checking if p tag has image then adding class*/

jQuery(function () {
  $(".article-content p").each(function (index) {
    if ($(this).html().indexOf("<img") > -1) {
      // console.log(vaar);
      $(this).addClass("full-width");
    }

    if ($(this).html().indexOf("<iframe") > -1) {
      $(this).addClass("full-width");
    }
  });
});
jQuery(function () {
  $(".full-format p").each(function (index) {
    if ($(this).html().indexOf("<img") > -1) {
      // console.log(vaar);
      $(this).addClass("full-width");
    }

    if ($(this).html().indexOf("<iframe") > -1) {
      $(this).addClass("full-width");
    }
  });
});
jQuery(function () {
  $(".full-format").children("div").each(function (index) {
    if ($(this).html().indexOf("<img") > -1) {
      // console.log(vaar);
      $(this).addClass("full-width");
    }

    if ($(this).html().indexOf("<iframe") > -1) {
      $(this).addClass("full-width");
    }
  });
}); // jQuery(document).ready(function ($) {
//     // Get the element
//     for (var i = 0; i < 250; i++) {
//       var marqueeFooter = document.querySelector('.js__marquee-right .repeat');
//       // Create a copy of it
//       var cloneFooter = marqueeFooter.cloneNode(true);
//       // Inject it into the DOM
//       marqueeFooter.before(cloneFooter);
//     }
//   });
// Footer dropdown

(function ($) {
  $(function () {
    var navLink = false;
    $(".accordion-toggle-footer-link").on("mousedown", function (e) {
      "use strict";

      e.stopImmediatePropagation();

      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).siblings(".accordion-content-footer").slideUp(300);
      } else {
        $(".accordion-toggle-footer-link").removeClass("active");
        $(this).addClass("active");
        $(".accordion-content-footer").slideUp(300);
        $(this).siblings(".accordion-content-footer").slideDown(300);
      }

      navLink = true;
    });
  });
})(jQuery);

jQuery(document).ready(function ($) {
  var collectionProductSlider = new Swiper(".js__collection-product-slider", {
    slidesPerView: 3,
    spaceBetween: 20,
    resistance: false,
    shortSwipes: true,
    loop: false,
    threshold: 5
  });
  /*Collection filter*/

  $(".js__collection-tab-filter a").on("click", function (e) {
    var collectionID = $(this).attr("data-collection");

    if ($(".js__collection-tab-filter a").parent("li").hasClass("active")) {
      $(".js__collection-tab-filter a").parent("li").removeClass("active");
      $(this).parent("li").addClass("active");
    } else {
      $(this).parent("li").addClass("active");
    }

    collectionFilter(collectionID);
  });

  function collectionFilter(collectionID) {
    // $(".js__collection-tab-filter").children("li").removeClass("active");
    $(".js__collection-tab-" + collectionID).addClass("active");
    $(".js__collection-product-slider").find(".swiper-slide").addClass("remove-slide").removeClass("swiper-slide");
    $(".js__collection-product-slider").find("." + collectionID).removeClass("remove-slide").addClass("swiper-slide");
    collectionProductSlider.destroy();
    collectionProductSlider = new Swiper(".js__collection-product-slider", {
      slidesPerView: 3,
      spaceBetween: 20,
      resistance: false,
      shortSwipes: true,
      loop: false,
      threshold: 5
    });
  }

  $(".js__collection-tab-filter li:first-child").children("a").click();
});
"use strict";

var showCartMessage = true;
jQuery(function () {
  //Nav - Open and Close Mini cart
  if (getglobalLib("Mini_Cart") == "yes") {
    $(".js__cart-expand").on("click", function () {
      $("#CartSidebar").toggleClass("active");
      $("#cart_overlay").toggleClass("active");
      $(this).addClass("active");
    });
    $("#js__cart-close").on("click", function () {
      $("#CartSidebar").removeClass("active");
      $("#cart_overlay").removeClass("active");
      $(".js__cart-expand").removeClass("active");
    });
    $(".js__cart-expand").attr("href", "javascript:void(0)");
  }
  /* Cart - Free Shipping Progress bar Visiblity */


  try {
    if (getglobalLib("Free_Shipping_progressbar") == "yes" && $(".js__free-shipping-limit").html().trim() != "" && showProgressBar == true) {
      $(".js__progressbar_visiblity").removeClass("hide");
    }
  } catch (_unused) {}
  /* Remove mini cart from the cart page */


  if ($(".cart-table-body")[0]) {
    $("#CartSidebar").remove();
    $("#cart_overlay").remove();
    $(".js__top-cart-form-actions").remove();
    $(".js__ajax-products-bind").remove();
    $(".mini-cart").removeClass("js__cart-expand");
    $(".mini-cart").attr("href", "/cart");
  }
  /* show no items in cart */


  if (CartJS.cart.item_count == 0) {
    $(".empty-cart-section").show();
    $(".js__show-cart-items-section").hide();
    $("#shopify-section-cart-recommendations").hide();
  } else {
    $(".empty-cart-section").hide();
  }
  /*Quantity Plus Minus for the textbox */


  $(".js__product-single__quantity .js__minus-qty").click(function () {
    decreaseQuantity();
  });
  $(".js__product-single__quantity .js__plus-qty").click(function () {
    increaseQuantity();
  });

  function increaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();
    productQuantity++;
    $(".js__quantity-selector").val(productQuantity);
  }

  function decreaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();

    if (productQuantity > 1) {
      productQuantity--;
    }

    $(".js__quantity-selector").val(productQuantity);
  }
});
/* 
NOTIFICATIONS SECTION
Show Noticiations On Success and Error
Note: This function isn't being used in every theme
Feel free to comment/uncomment as per the functionality
*/

function showCartSuccessMessage() {
  setTimeout(openMiniCart, 500);

  if (showCartMessage == true) {
    $("#cart-message").addClass("message-success");
    $("#cart-message").removeClass("message-error");
    $("#cart-message").html("Successfully added to cart!");
    $("#cart-message").show();
    setTimeout(function () {
      $("#cart-message").hide();
    }, 5000);
  }
}

function showCartErrorMessage() {
  if (showCartMessage == true) {
    $("#cart-message").removeClass("message-success");
    $("#cart-message").addClass("message-error");
    $("#cart-message").html("Sorry! Seems like the product is out of stock");
    $("#cart-message").show();
    setTimeout(function () {
      $("#cart-message").hide();
    }, 5000);
  }
}

function openMiniCart() {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    return res.json();
  }).then(function (data) {
    $("#CartSidebar").toggleClass("active");
    $("#cart_overlay").toggleClass("active");
  });
}
/* EVENT: When the cart request is completed everytime the below function is run */


$(document).on("cart.requestComplete", function (event, cart) {
  console.log("On cart request complete");
  reloadAjaxCartItemUsingCartAjaxObject(cart); //Progress Bar of shipping in cart and mini cart; Varies from theme to theme

  progressBar(); //Show and hide empty cart depending upon the cart items

  setTimeout(function () {
    // calculateSubTotalWithDiscount is called here but defined nowhere in any
    // bundle this theme loads, so every cart update threw and addons() on the
    // next line never ran. Guarded rather than removed in case the function is
    // reintroduced later.
    if (typeof calculateSubTotalWithDiscount === 'function') {
      calculateSubTotalWithDiscount();
    }
    addons();
  }, 1000);
}); // $(document).on("cart.requestStarted", function (event, cart) {console.log("Request started"); });
//$(document).on("cart.ready", function (event, cart) {});

/* currency formatter */

var formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});
"use strict";

jQuery(function () {
  /* Footer - Accordion Visiblity */
  if (getglobalLib("Footer_Accordion") == "yes") {
    $(".js__accordion-toggle-visiblity").addClass("accordion-toggle-footer");
    $(".js__accordion-content-visiblity").addClass("accordion-content-footer");
  }
  /* FAQ - Category Sidebar Visiblity */


  if (getglobalLib("FAQ_Side_Panel") == "yes") {
    $(".js__faq-category-side-panel").removeClass("hide");
  }

  if (getglobalLib("Product_Recommendation_Slider") == "on") {
    $("#js__pdp-recommendation-slider").not(".slick-initialized").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: false,
      centerMode: false,
      infinite: false,
      focusOnSelect: true,
      variableWidth: true,
      draggable: true
    });
  }
});
"use strict";

jQuery(function () {
  /* Global
  Announcement Slider */
  var announcementSlider = new Swiper(".js__announcement-slider", {
    slidesPerView: 1,
    resistance: false,
    shortSwipes: true,
    loop: false,
    autoHeight: true,
    threshold: 5
    /*  autoplay: {
          delay: 3000,
      }*/

  });
  /* Announcement 
  Close on Click  */

  $("#announcement-close").on("click", function () {
    $(".announcement-bar").hide();
    $("body").removeClass("announcement-visible");
  });

  if ($("div").hasClass("hero-banner") || $("div").hasClass("error-page") || $("body").hasClass("template-page") || $("div").hasClass("inner-hero-section")) {
    $("body").addClass("transparent-header");
  } else {
    $("body").removeClass("transparent-header");
  }
  /* MEGAMENU
    active link while submenu open */


  if ($(window).width() > 980) {
    $('.has-sub-nav').hover(function (event) {
      event.stopPropagation(); // Stop event propagation
      // Adding a extra link to give anchor hover effect

      $(this).children(".site-nav__link").addClass("hover-submenu"); // Give Visibility and opacity to the Sub nav menu

      $(this).children(".sub-nav").css("visibility", "visible");
      $(this).children(".sub-nav").css("opacity", "1");
      $(this).children(".sub-nav").css("z-index", "1"); // Remove transparent header from index page when sub menu open
      // $(".template-index").addClass("remove-transparent-header");

      $("body").removeClass("transparent-header");
      $(".main-header").addClass("active");

      if ($(".js__header-search-section").hasClass("active")) {
        $(".js__header-search-section").removeClass("active"); // $(".js__main-header").addClass("active");
        // $("body").removeClass("transparent-header");

        $(".js__search").removeClass("active");
      }

      if ($("#navbarNavDropdown").hasClass("active")) {
        $(".js__logo").addClass("active");
        $("body").removeClass("transparent-header");
        $(".main-header").addClass("active");
      }
    }, function (event) {
      event.stopPropagation(); // Stop event propagation
      // Remove  extra link to remove anchor hover effect

      $(this).children(".site-nav__link").removeClass("hover-submenu");
      $(".has-sub-nav").children(".site-nav__link").removeClass("hover-submenu"); // Remove Visibility and opacity from the Sub nav menu

      $(".has-sub-nav").children(".sub-nav").css("visibility", "hidden");
      $(".has-sub-nav").children(".sub-nav").css("opacity", "0");
      $(".main-header").removeClass("active");
      $(this).children(".sub-nav").css("z-index", "-10"); // $("body").removeClass("remove-transparent-header");
      // Add transparent header from index page when sub menu open
      // $(".template-index").addClass("transparent-header");

      if ($("body").hasClass("fixed-header")) {
        $("body").removeClass("transparent-header");
      }

      if ($("#navbarNavDropdown").hasClass("active")) {
        $(".js__logo").addClass("active");
        $("body").removeClass("transparent-header");
        $(".main-header").addClass("active");
      } else {
        // $("body").addClass("transparent-header");
        if ($(".main-header").hasClass("active")) {
          $("body").removeClass("transparent-header");
        } else {
          if ($("div").hasClass("hero-banner") || $("div").hasClass("error-page") || $("body").hasClass("template-page") || $("div").hasClass("inner-hero-section")) {
            $("body").addClass("transparent-header");
          } else {
            if ($("div").hasClass("white-bg") === true) {
              $("body").removeClass("transparent-header");
              $("body").removeClass("template-index");
            }

            $("body").removeClass("transparent-header");
          }
        }
      }
    });
    $('.has-big-nav').hover(function (event) {
      event.stopPropagation(); // Stop event propagation
      // Adding a extra link to give anchor hover effect

      $(this).children(".site-nav__link").addClass("hover-submenu"); // Give Visibility and opacity to the Big nav menu

      $(this).children(".big-nav").css("visibility", "visible");
      $(this).children(".big-nav").css("opacity", "1"); // Remove transparent header from index page when big nav menu open

      $("body").removeClass("transparent-header");
      $(".main-header").addClass("active");

      if ($(".js__header-search-section").hasClass("active")) {
        $(".js__header-search-section").removeClass("active"); // $(".js__main-header").addClass("active");
        // $("body").removeClass("transparent-header");

        $(".js__search").removeClass("active");
      }

      if ($("#navbarNavDropdown").hasClass("active")) {
        $(".js__logo").addClass("active");
        $("body").removeClass("transparent-header");
        $(".main-header").addClass("active");
      }
    }, function (event) {
      event.stopPropagation(); // Stop event propagation
      // Remove  extra link to remove anchor hover effect

      $(this).children(".site-nav__link").removeClass("hover-submenu"); // Remove Visibility and opacity from the Big nav menu

      $(".has-big-nav .big-nav").css("visibility", "hidden");
      $(".has-big-nav .big-nav").css("opacity", "0");
      $(".main-header").removeClass("active"); // Add transparent header from index page when sub menu open

      if ($("body").hasClass("fixed-header")) {
        $("body").removeClass("transparent-header");
      }

      if ($("#navbarNavDropdown").hasClass("active")) {
        $(".js__logo").addClass("active");
        $("body").removeClass("transparent-header");
        $(".main-header").addClass("active");
      } else {
        // $("body").addClass("transparent-header");
        if ($(".main-header").hasClass("active")) {
          $("body").removeClass("transparent-header");
        } else {
          if ($("div").hasClass("hero-banner") || $("div").hasClass("error-page") || $("body").hasClass("template-page") || $("div").hasClass("inner-hero-section")) {
            $("body").addClass("transparent-header");
          } else {
            if ($("div").hasClass("white-bg") === true) {
              $("body").removeClass("transparent-header");
              $("body").removeClass("template-index");
            }

            $("body").removeClass("transparent-header");
          }
        }
      } // $(".template-index").addClass("transparent-header");

    });
  } //  Sub Menu in MObile

  /* SubMenu
     Accordion JS */


  (function ($) {
    $(function () {
      var navLink = false;
      $(".accordion-toggle").on("mousedown", function (e) {
        "use strict";

        e.stopImmediatePropagation();

        if ($(this).parent("div").hasClass("footer-links")) {
          if ($(window).width() < 981) {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content").slideUp(300);
            } else {
              $(".accordion-toggle").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content").slideUp(300);
              $(this).siblings(".accordion-content").slideDown(300);
            }
          }
        } else {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".accordion-content").slideUp(300);
          } else {
            $(".accordion-toggle").removeClass("active");
            $(this).addClass("active");
            $(".accordion-content").slideUp(300);
            $(this).siblings(".accordion-content").slideDown(300);
          }
        }

        navLink = true;
      }).focus(function (e) {
        "use strict";

        if (navLink) {
          navLink = false;
        } else {
          if ($(this).parent("div").hasClass("footer-links")) {
            if ($(window).width() < 980) {
              if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).siblings(".accordion-content").slideUp(300);
              } else {
                $(".accordion-toggle").removeClass("active");
                $(this).addClass("active");
                $(".accordion-content").slideUp(300);
                $(this).siblings(".accordion-content").slideDown(300);
              }
            }
          } else {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content").slideUp(300);
            } else {
              $(".accordion-toggle").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content").slideUp(300);
              $(this).siblings(".accordion-content").slideDown(300);
            }
          }
        }
      });
    });
    $(function () {
      var navLink = false;
      $(".accordion-toggle-inner").on("mousedown", function (e) {
        "use strict";

        e.stopImmediatePropagation();

        if ($(this).parent("div").hasClass("footer-links")) {
          if ($(window).width() < 980) {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content-inner").slideUp(300);
            } else {
              $(".accordion-toggle-inner").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content-inner").slideUp(300);
              $(this).siblings(".accordion-content-inner").slideDown(300);
            }
          }
        } else {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".accordion-content-inner").slideUp(300);
          } else {
            $(".accordion-toggle-inner").removeClass("active");
            $(this).addClass("active");
            $(".accordion-content-inner").slideUp(300);
            $(this).siblings(".accordion-content-inner").slideDown(300);
          }
        }

        navLink = true;
      }).focus(function (e) {
        "use strict";

        if (navLink) {
          navLink = false;
        } else {
          if ($(this).parent("div").hasClass("footer-links")) {
            if ($(window).width() < 980) {
              if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).siblings(".accordion-content-inner").slideUp(300);
              } else {
                $(".accordion-toggle-inner").removeClass("active");
                $(this).addClass("active");
                $(".accordion-content-inner").slideUp(300);
                $(this).siblings(".accordion-content-inner").slideDown(300);
              }
            }
          } else {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content-inner").slideUp(300);
            } else {
              $(".accordion-toggle-inner").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content-inner").slideUp(300);
              $(this).siblings(".accordion-content-inner").slideDown(300);
            }
          }
        }
      });
    });
  })(jQuery);

  if ($("div").hasClass("inner-hero-section") || $("div").hasClass("error-page") || $("body").hasClass("template-page") || $("div").hasClass("hero-banner")) {
    $("body").addClass("transparent-header");
    $("body").addClass("template-index");
  } // sEARCH BAR


  $(document).click(function (e) {
    var container = $(".search-li");

    if (container.css("display") != "none") {
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".js__header-search-section").removeClass("active");
        $(".js__search").removeClass("active");

        if ($("div").hasClass("inner-hero-section") || $("div").hasClass("error-page") || $("body").hasClass("template-page") || $("div").hasClass("hero-banner")) {
          if ($("body").hasClass("fixed-header") === true) {
            $("body").removeClass("transparent-header");
          } // else{
          //     $("body").addClass("transparent-header");
          // }
          // $("body").addClass("transparent-header");
          // $("body").addClass("template-index");

        } else {
          $("body").removeClass("transparent-header");
        }
      }
    }
  });
  $(".js__search").on("click", function (e) {
    e.preventDefault();
    $(".js__header-search-section").toggleClass("active");
    $("#navbarNavDropdown").removeClass("active");
    $(".announcement-bar").removeClass("active");
    $("#shopify-section-announcement").removeClass("active");
    $("#hamburger").removeClass("active");
    $(".boost-pfs-search-box").focus();
    $(this).toggleClass("active");
    $(".js__main-header").toggleClass("active");
    $("body").removeClass("transparent-header");
  });

  if ($(".js__header-search-section").hasClass("active")) {
    $(".js__main-header").addClass("active");
    $("body").removeClass("transparent-header");
  } else {
    $(".js__main-header").removeClass("active");

    if ($("div").hasClass("hero-banner") || $("div").hasClass("error-page") || $("body").hasClass("template-page") || $("div").hasClass("inner-hero-section")) {
      $("body").addClass("transparent-header");
    } else {
      $("body").removeClass("transparent-header");
    }
  }

  $(".search-close").on("click", function (e) {
    $(".js__header-search-section").toggleClass("active");
    $("#navbarNavDropdown").removeClass("active");
    $(".announcement-bar").removeClass("active");
    $("#shopify-section-announcement").removeClass("active");
    $("#hamburger").removeClass("active");
    $(".js__search").toggleClass("active");
    $(".js__main-header").toggleClass("active");

    if ($("body").hasClass("fixed-header") === true) {
      $("body").removeClass("transparent-header");
    } else {
      if ($("div").hasClass("hero-banner") || $("div").hasClass("error-page") || $("body").hasClass("template-page") || $("div").hasClass("inner-hero-section")) {
        $("body").addClass("transparent-header");
      }
    }
  }); // sEARCH BAR end
});
/** Fix Header on Scroll **/

$(window).scroll(function () {
  var sticky = $("header"),
      scroll = $(window).scrollTop();

  if (scroll >= 38) {
    sticky.addClass("fixed");
    $("body").addClass("fixed-header");
    $("body").removeClass("transparent-header");
  } else {
    sticky.removeClass("fixed");
    $("body").removeClass("fixed-header");
    $(".main-header").removeClass("active");

    if ($("#navbarNavDropdown").hasClass("active")) {
      $("body").removeClass("transparent-header");
      $(".main-header").addClass("active");
    } else {
      if ($("div").hasClass("hero-banner") || $("div").hasClass("error-page") || $("body").hasClass("template-page") || $("div").hasClass("inner-hero-section")) {
        $("body").addClass("transparent-header");
      } else {
        $("body").removeClass("transparent-header");
      }
    }

    if ($(".js__main-header").hasClass("active") === true) {
      $("body").removeClass("transparent-header");
    } else {
      if ($("div").hasClass("hero-banner") || $("div").hasClass("error-page") || $("body").hasClass("template-page") || $("div").hasClass("inner-hero-section")) {
        $("body").addClass("transparent-header");
      } else {
        $("body").removeClass("transparent-header");
      } //   $("body").removeClass("transparent-header");

    }
  }
});
/** used when header is relative **/

/** Fix Header on Scroll **/
// document.addEventListener("DOMContentLoaded", function() {
//     window.addEventListener("scroll", function() {
//         var scrollHeight = 35;
//         if (window.scrollY > scrollHeight) {
//             document.getElementById("navbarNavDropdown").classList.add("fixed");
//             // add padding top to show content behind navbar
//             var navbar_height =
//                 document.querySelector(".navbar-collapse").offsetHeight;
//             document.body.style.paddingTop = navbar_height + "px";
//         } else {
//             document.getElementById("navbarNavDropdown").classList.remove("fixed");
//             // remove padding top from body
//             document.body.style.paddingTop = "0";
//         }
//     });
// });

/** Mobile Navigation Open Close **/

(function ($) {
  $(function () {
    var navLink = false;
    $("#hamburger").mousedown(function (e) {
      $(this).toggleClass("active");
      $("body").removeClass("transparent-header");
      $("#navbarNavDropdown").toggleClass("active");
      $(".js__mobile-menu-open-hide").toggleClass("active");
      $(".js__mobile-announcement-text").toggleClass("active");
      $(".main-header").toggleClass("active");
      $(".announcement-bar").toggleClass("active");
      $("#shopify-section-announcement").toggleClass("active");

      if ($("body").hasClass("transparent-header")) {
        $("body").removeClass("transparent-header");
      }

      if ($("#navbarNavDropdown").hasClass("active")) {
        $(".js__logo").addClass("active");
        $("body").removeClass("transparent-header");
        $(".main-header").addClass("active");

        if ($(window).width() < 980) {
          $("html").css("overflow", "hidden");
          $("html").addClass("scroll-stop");
        } else {
          $("html").removeClass("scroll-stop");
          $("html").css("overflow-y", "scroll");
        }
      } else {
        $(".js__logo").toggleClass("active");
        $(".main-header").removeClass("active");

        if ($("body").hasClass("fixed-header")) {
          $("body").removeClass("transparent-header");
        } else {
          $("body").addClass("transparent-header");
        }

        $("html").css("overflow-y", "scroll");
      }

      navLink = true;
    }); // .focus(function(e) {
    //     "use strict";
    //     if (navLink) {} else {
    //         $(this).toggleClass("active");
    //         $("#navbarNavDropdown").toggleClass("active");
    //         $(".js__mobile-menu-open-hide").toggleClass("active");
    //         $(".js__mobile-announcement-text").toggleClass("active");
    //         if ($("#navbarNavDropdown").hasClass("active")) {
    //             $(".js__logo").addClass("active");
    //             $("body").removeClass("transparent-header");
    //         } else {
    //             $(".js__logo").toggleClass("active");
    //             $("body").addClass("transparent-header");
    //         }
    //     }
    // });
  });
})(jQuery);
/** CART SIDEBAR
 * Close on Outside Click
 * **/


$(document).mouseup(function (e) {
  var popup = $("#CartSidebar");
  var overlay = $("#cart_overlay");

  if (!popup.is(e.target) && popup.has(e.target).length == 0) {
    popup.removeClass("active");
    overlay.removeClass("active");
  }
});
/* OPEN BIG NAV SECTION ON DESKTOP */

(function ($) {
  $(function () {
    var navLink = false;
    $(".js__big-nav-link").mousedown(function (e) {
      $(this).toggleClass("active");
      $(".js__big-nav").toggleClass("active");
      navLink = true;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        $(this).toggleClass("active");
        $(".js__big-nav").toggleClass("active");
      }
    });
  });
})(jQuery);
/* OPEN SUB NAV SECTION ON MOBILE */


(function ($) {
  $(function () {
    var navLink = false;
    $(".js__sub-nav-link").mousedown(function (e) {
      $(this).toggleClass("active");
      $(".js__sub-nav").toggleClass("active");
      navLink = true;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        $(this).toggleClass("active");
        $(".js__sub-nav").toggleClass("active");
      }
    });
  });
})(jQuery); // CLOSE MOBILE BIG NAV ON CLICK BACK


(function ($) {
  $(function () {
    var navLink = false;
    $(".js__big-nav-close").mousedown(function (e) {
      $(this).toggleClass("active");
      $(".js__big-nav").toggleClass("active");
      navLink = true;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        $(this).toggleClass("active");
        $(".js__big-nav").toggleClass("active");
      }
    });
  });
})(jQuery); // Close MOBILE SUB NAV ON CLICK BACK 


(function ($) {
  $(function () {
    var navLink = false;
    $(".js__sub-nav-close").mousedown(function (e) {
      $(this).toggleClass("active");
      $(".js__sub-nav").toggleClass("active");
      navLink = true;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        $(this).toggleClass("active");
        $(".js__sub-nav").toggleClass("active");
      }
    });
  });
})(jQuery);
"use strict";

var pdpThumbnail;
var pdpSlider;
$(document).ready(function ($) {
  var producrSlider = new Swiper('.js__pdp-recommendation-slider', {
    slidesPerView: 3,
    autoHeight: true,
    resistance: false,
    shortSwipes: true,
    threshold: 5,
    spaceBetween: 40,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next-product-recommed',
      prevEl: '.swiper-button-prev-product-recommed'
    },
    breakpoints: {
      0: {
        slidesPerView: 1
      },
      601: {
        slidesPerView: 2
      },
      981: {
        slidesPerView: 3
      }
    }
  });
  /*Slider working Start*/

  if (getglobalLib("PDP_Slider_Thumbnail") == "vertical") {
    pdpThumbnail = new Swiper(".js__pdp-thumbnail-slider", {
      threshold: 5,
      slidesPerView: 4,
      resistance: false,
      shortSwipes: false,
      clickable: true,
      grabCursor: true,
      observer: true,
      observeParents: true,
      draggable: true,
      // spaceBetween: 20,
      breakpoints: {
        981: {
          slidesPerView: 4
        }
      }
    });
  } else {
    pdpThumbnail = new Swiper(".js__pdp-thumbnail-slider", {
      resistance: false,
      shortSwipes: true,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      clickable: true,
      grabCursor: true,
      mousewheel: true,
      spaceBetween: 20,
      threshold: 5
    });
  }

  pdpSlider = new Swiper(".js__pdp-slider", {
    slidesPerView: 1,
    grabCursor: false,
    mousewheel: false,
    clickable: false,
    resistance: false,
    shortSwipes: true,
    threshold: 5,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next-pdp",
      prevEl: ".swiper-button-prev-pdp"
    },
    pagination: {
      el: '.pdp-slider__pagination',
      clickable: true,
      type: 'custom',
      renderCustom: function renderCustom(swiper, current, total) {
        //   return (
        //     '<span class="current">' + 0 + current + '</span>' + '/' + '<span class="total">' + 0 + total + '</span>'
        //   );
        if (current > 9) {
          return '<span class="current">' + current + '</span>' + '/' + '<span class="total">' + total + '</span>';
        } else {
          if (total > 9) {
            return '<span class="current">' + 0 + current + '</span>' + '/' + '<span class="total">' + total + '</span>';
          }

          return '<span class="current">' + 0 + current + '</span>' + '/' + '<span class="total">' + 0 + total + '</span>';
        }
      }
    },
    thumbs: {
      swiper: pdpThumbnail
    }
  });
  /*PDP tab section drop down change*/

  $(".js__pdp-tab-select").change(function () {
    $(".tab-content").removeClass("active");
    $(".tab-content").hide();
    $("#" + $(this).val()).show();
    $("#" + $(this).val()).addClass("active");
    $(".tab-link").removeClass("active");
    $("#tab-link-" + $(this).val()).addClass("active");
  });
  /* var pdpSlideCount = 0;
   $(document).on("click", ".swiper-button-next-pdp.swiper-button-disabled", function(e) {
           var ariaLabel = $(".js__pdp-slider").find(".swiper-slide-active").attr("aria-label").split("/");
           console.log(ariaLabel[0]);
           console.log(ariaLabel[1]);
           pdpSlideCount++;
           if (pdpSlideCount == 2) {
               if (ariaLabel[0].trim() == ariaLabel[1].trim()) {
                   pdpSlideCount = 0
                   pdpSlider.slideTo(0);
               }
           }
         })*/

  /* Manual click of thumbnail of slider*/

  $(document).on("click", ".pdp-thumbnail li", function (e) {
    var slideno = $(this).index();
    $(".pdp-thumbnail li").removeClass("active");
    $(this).addClass("active");
    $(".pdp-slider").slick("slickGoTo", slideno);
    setTimeout(function () {
      $(".pdp-thumbnail").slick("slickGoTo", slideno);
    }, 500);
    /* var slideno = $(this).index();
             $(".pdp-thumbnail li").removeClass("active");
             $(this).addClass("active");
             console.log("slideno"+slideno);
       
             $(".pdp-slider").slick("slickGoTo", slideno);*/
  });
  /*Write review click*/

  $(document).on("click", ".jdgm-write-rev-link", function (e) {
    e.preventDefault();
    $(".jdgm-form-wrapper").show();
  });
  /*View details*/

  $(document).on("click", ".js__pdp-view-details", function (e) {
    e.preventDefault();
    $(".tab-link").removeClass("active");
    $(".tab-head li:first-child").children(".tab-link").addClass("active");
    $(".tab-content").removeClass("active");
    $(".tab-content:first-child").addClass("active");
    $(".tab-content").hide();
    $(".tab-content:first-child").show();
    $(".js__pdp-tab-select").val($(".tab-head li:first-child").children(".tab-link").attr("data-attr"));
    setTimeout(function () {
      var target = $(".tab-content:first-child");
      $("html, body").animate({
        scrollTop: target.offset().top - 350
      }, 500);
    }, 500);
  });
  /*Review star click*/

  $(document).on("click", ".js__review-section", function (e) {
    e.preventDefault();
    $(".tab-link").removeClass("active");
    $("#tab-link-reviews").addClass("active");
    $(".tab-content").removeClass("active");
    $("#reviews").addClass("active");
    $(".tab-content").hide();
    $("#reviews").show();
    $(".js__pdp-tab-select").val("Reviews");
    setTimeout(function () {
      var target = $("#reviews");
      $("html, body").animate({
        scrollTop: target.offset().top - 350
      }, 500);
    }, 500);
  });
  /*Ninja price update */

  var targetNodes = $(".product__form");
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  var bundleObersrver = new MutationObserver(mutationHandler);
  var obsConfig = {
    childList: true,
    characterData: true,
    attributes: true,
    subtree: true
  }; //--- Add a target node to the observer. Can only add one node at a time.

  targetNodes.each(function () {
    bundleObersrver.observe(this, obsConfig);
  });

  function mutationHandler(mutationRecords) {
    //loop through all the mutations that just occured
    mutationRecords.forEach(function (mutation) {
      if (mutation.type == "childList") {
        //loop though the added nodes
        mutation.addedNodes.forEach(function (added_node) {
          console.log($(".rc-container-wrapper").html());

          if ($(".rc-container-wrapper").html() != undefined) {
            console.log("click recharge active");
            setTimeout(function () {
              $(".rc-option--active").click();
            }, 500);
            bundleObersrver.disconnect();
          }
        });
      }
    });
  }
  /* change frequency dropdown checking if   value not null then change button text */


  $(document).on("change", ".rc_widget__option__plans__dropdown", function (e) {
    $(".rc-option--active").click();
  });
  $(document).on("click", ".rc_widget__option", function (e) {
    //console.log("onetime ");
    var price = $(this).find(".rc-option__price").html();
    $(".pdp-add-to-cart-price").html(price);
  });
  /*Slider working End*/

  /* Call page load functions */

  setTimeout(function () {
    setColorThumbImages();
  }, 1000);
  /* FORMATTING: Loop Through each color thumb and set the images for them through the product color library object */

  function setColorThumbImages() {
    if ($(".js-variant-color-swatch li")[0]) {
      $(".js-variant-color-swatch  li").each(function (index) {
        var color = $(this).attr("data-color");
        var colorValue = getVariantColor(color); //$(this).children("div.color").css("background-color", colorValue);

        if (colorValue == "") {
          $(this).children("img").css("opacity", "0");
        }

        $(this).children("img").attr("src", colorValue);
      });
    }
  }
});
/*PENDING Get Variant Color*/

function getVariantColor(color) {
  try {
    var variantColorValue = "";
    $.each(prodColor, function (key, value) {
      if (color.toLowerCase() == value.title.toLowerCase()) {
        variantColorValue = value.color;
      }
    });
    /* $.each(prodLib, function (key, value) {
       if (color.toLowerCase() == value.option1.toLowerCase()) {
         variantColorValue = value.image;
       }
     });*/

    return variantColorValue;
  } catch (_unused) {}
}
/* Color swatch click*/


$(document).ready(function ($) {
  $(document).on("mouseenter", ".js__product-cart-color li", function () {
    var productID = $(this).attr("data-product-id");
    var variantImage = $(this).attr("data-image");
    var featuredImage = $(this).attr("data-featured_image");

    if (variantImage.indexOf("no-image-") == -1) {
      $(".js__product-image-" + productID).attr("src", variantImage);
    } else {
      $(".js__product-image-" + productID).attr("src", featuredImage);
    }
  });
  $(document).on("mouseleave", ".js__product-cart-color li", function () {
    var productID = $(this).attr("data-product-id");
    var featuredImage = $(".js__product-image-" + productID).attr("data-src");
    $(".js__product-image-" + productID).attr("src", featuredImage);
  });
  $(document).on("click", ".js__edition-section li", function (e) {
    e.preventDefault();
    var edition = $(this).attr("data-edition");
    $(".js__edition-section li").removeClass("active");
    $(this).addClass("active");
    $(".js__signal-pro-edition").removeClass("active");
    $(".js__standard-edition").removeClass("active");
    $("." + "js__" + edition + "-edition").addClass("active");
  });
});
"use strict";

var colorSelected = "";
var secondOptionVariantValue = "";
var thirdOptionVariantValue = "";
var selectedVariantID;
$(document).ready(function ($) {
  /* if no varient then active class added in product image section*/
  if (prodLib.length == 0) {
    $(".js-pdp-media").addClass("active");
    $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
  }

  var colorPosition = $("#colorPosition").val();
  var numberOfAvailableOptions = parseInt($("#optionSize").val()); // on page load check the color position, and set 2nd and 3rd options values

  checkColorPosition();

  function checkColorPosition() {
    getColorPosition();
    /* 
    if only color and no other options
    */

    if (colorPosition != undefined && numberOfAvailableOptions == 1) {
      SoldOutUnavailableOnColorSwatches(colorSelected);
    }
  }
  /*Quantity Plus Minus*/


  $(".js-product-single__quantity .js-plus-minus-qty").click(function () {
    var type = $(this).attr("data-type");
    var productQuantity = $(".js-quantity-selector").val();

    if (type == "minus") {
      if (productQuantity > 1) {
        productQuantity--;
      }
    } else {
      productQuantity++;
    }

    $(".js-quantity-selector").val(productQuantity);
  }); // On DD change, fire the form DD element and also run the soldoutColorSwatches function

  $(".js__pdp-variant-select").change(function () {
    var optionIndex = $(this).attr("data-option");
    var optionValue = $(this).val();
    $("#product .product__form .options .option.option-" + optionIndex + " .label span").text(optionValue); // button  - Sold out and add to cart

    $("#product-select-option-" + optionIndex).val(optionValue).trigger("change");
    /*Checking if this is filter type then image filter code will work*/

    var OptionType = $(this).attr("data-type");
    var FilterType = $("#variantFilterType").val();

    if (OptionType == FilterType) {
      imageFilter(optionValue);
    }

    var selectedVariant = $("#product-select :selected").text().replace("- sold out!", "");
    $(".js__product-variant-selected").html(selectedVariant);
    $(".rc-option--active").click(); //color swatch - sold out working

    SoldOutUnavailableOnColorSwatches(colorSelected);
  });
  $(".js__color-swatches").click(function () {
    // remove active class - from all the li's
    $('.js__color-swatches').removeClass('active'); // add class on the one which is clicked

    $(this).addClass('active');
    var optionindex = $(this).data('option');
    var thevalue = $(this).data('value'); //show the selected value

    $('.variant-option.option-' + optionindex + ' .label span').text(thevalue); // trigger change

    $('#product-select-option-' + optionindex).val(thevalue).trigger('change');
    /*Checking if this is filter type then image filter code will work*/

    var OptionType = $(this).parent("ul").attr("data-type");
    var FilterType = $("#variantFilterType").val();

    if (OptionType == FilterType) {
      imageFilter(thevalue);
    }
  });

  function imageFilter(selectedValue) {
    /*Slick slider filter on swatch click*/
    var thumbColorSelected = selectedValue.replace(" ", "-");
    thumbColorSelected = thumbColorSelected.replace(/[^a-zA-Z0-9 ]/g, "-");
    thumbColorSelected = thumbColorSelected.replace(/ /g, "-");
    thumbColorSelected = thumbColorSelected.replace(/--/g, "-");
    thumbColorSelected = thumbColorSelected.replace(/---/g, "-"); // $(".pdp-slider").slick("slickUnfilter");
    //   $(".js__pdp-thumbnail-slider").slick("slickUnfilter");

    $(".pdp-slider").find(".all").addClass(thumbColorSelected.toLowerCase());
    $(".js__pdp-thumbnail-slider").find(".all").addClass(thumbColorSelected.toLowerCase()); //   $(".pdp-slider").slick("slickFilter", "." + thumbColorSelected.toLowerCase());
    //  $(".js__pdp-thumbnail-slider").slick( "slickFilter","." + thumbColorSelected.toLowerCase());

    $(".js__pdp-thumbnail-slider .swiper-slide").removeClass("active"); //$(".js__pdp-thumbnail-slider").slick("refresh");

    $(".pdp-slider").find(".slide").addClass("remove-slide").removeClass("swiper-slide").removeAttr("aria-label");
    $(".js__pdp-thumbnail-slider").find(".slide").addClass("remove-slide").removeClass("swiper-slide").removeAttr("aria-label");
    $(".pdp-slider").find("." + thumbColorSelected.toLowerCase()).removeClass("remove-slide").addClass("swiper-slide");
    $(".js__pdp-thumbnail-slider").find("." + thumbColorSelected.toLowerCase()).removeClass("remove-slide").addClass("swiper-slide");
    pdpThumbnail.destroy();
    pdpSlider.destroy();

    if (getglobalLib("PDP_Slider_Thumbnail") == "vertical") {
      pdpThumbnail = new Swiper(".js__pdp-thumbnail-slider", {
        slidesPerView: 4,
        resistance: false,
        shortSwipes: false,
        freeMode: true,
        watchSlidesProgress: true,
        clickable: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        draggable: true,
        threshold: 5,
        breakpoints: {
          981: {
            slidesPerView: 4
          }
        }
      });
    } else {
      pdpThumbnail = new Swiper(".js__pdp-thumbnail-slider", {
        resistance: false,
        shortSwipes: true,
        loop: true,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        clickable: true,
        grabCursor: true,
        mousewheel: true,
        spaceBetween: 10,
        threshold: 5
      });
    }

    pdpSlider = new Swiper(".js__pdp-slider", {
      slidesPerView: 1,
      grabCursor: false,
      mousewheel: false,
      clickable: false,
      resistance: false,
      shortSwipes: true,
      loop: true,
      threshold: 5,
      navigation: {
        nextEl: ".swiper-button-next-pdp",
        prevEl: ".swiper-button-prev-pdp"
      },
      thumbs: {
        swiper: pdpThumbnail
      }
    });
    /*Selected first variant image in slider which have no all class*/

    var boolVariantFirstImage = false;
    $(".js__pdp-thumbnail-slider  li").each(function () {
      if (!$(this).hasClass("all")) {
        if (boolVariantFirstImage == false) {
          $(this).click();
          $(this).addClass("active");
          boolVariantFirstImage = true;
          console.log(boolVariantFirstImage);
        }
      }
    });
    /*When we dont have any variant image*/

    console.log(boolVariantFirstImage);

    if (boolVariantFirstImage == false) {
      $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
      $(".js__pdp-thumbnail-slider li:first-child").click();
    }

    colorSelected = selectedValue;
  } // main sold out and unavailable working


  function SoldOutUnavailableOnColorSwatches(colorSelected) {
    getColorPosition(); // Remove out of stock and unavailable from color swatches

    $(".js__color-swatches").removeClass("out-of-stock");
    $(".js__color-swatches").removeClass("unavailable");
    var colorLength = $(".js__color-swatches").length;
    var colorCount = 1;
    /*
    Loop Through each input radio for the color
    */
    // we are using color swatch working for other options when they are radio buttons

    $(".js__color-swatches").each(function (index) {
      var colorValue = $(this).attr("data-value");
      var checkColorOptionExists = false;
      /* 
       Loop through product library object for variant 
       and if variant select matches and quantity = 0 then show out of stock message
       */

      /*
      PENDING - Merge - ProdLib Each Function
      */

      $.each(prodLib, function (key, value) {
        var itemQuantity = value.quantity;
        var itemAvailable = value.available;
        var prodColorOptionValue = "";
        var prodSecondOptionValue = "";
        var prodThirdOptionValue = "";

        if (colorPosition == "1") {
          prodColorOptionValue = value.option1;
          prodSecondOptionValue = value.option2;
          prodThirdOptionValue = value.option3;
        }

        if (colorPosition == "2") {
          prodColorOptionValue = value.option2;
          prodSecondOptionValue = value.option1;
          prodThirdOptionValue = value.option3;
        }

        if (colorPosition == "3") {
          prodColorOptionValue = value.option3;
          prodSecondOptionValue = value.option1;
          prodThirdOptionValue = value.option2;
        }

        var colorOption = prodColorOptionValue.toLowerCase();
        colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
        colorOption = colorOption.replace(/ /g, "-");
        colorOption = colorOption.replace(/--/g, "-");
        colorOption = colorOption.replace(/---/g, "-");
        /*Checking each color  size quantity and which have 0 then added out of stock class*/

        if (numberOfAvailableOptions == 3) {
          /*three matching option checking quantity if 0 then showing out of stock */
          if (secondOptionVariantValue.toLowerCase() == prodSecondOptionValue.toLowerCase() && thirdOptionVariantValue.toLowerCase() == prodThirdOptionValue.toLowerCase()) {
            {
              //check if quantity>1 then set the color swatch - Out of stock
              setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
            }
          }
        } else if (numberOfAvailableOptions == 2) {
          /*two matching option checking quantity if 0 then showing out of stock */
          if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase()) {
            {
              //check if quantity>1 then set the color swatch - Out of stock
              setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
            }
          }
        } else {
          //check if quantity>1 then set the color swatch - Out of stock
          setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
        }

        if (prodColorOptionValue == colorValue) {
          if (numberOfAvailableOptions == 3) {
            if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase() && prodThirdOptionValue.toLowerCase() == thirdOptionVariantValue.toLowerCase()) {
              checkColorOptionExists = true;
            }
          } else if (numberOfAvailableOptions == 2) {
            if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase()) {
              checkColorOptionExists = true;
            }
          } else {
            checkColorOptionExists = true;
          }
        }
      });

      if (checkColorOptionExists == false) {
        var colorOption = colorValue;
        colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
        colorOption = colorOption.replace(/ /g, "-");
        colorOption = colorOption.replace(/--/g, "-");
        colorOption = colorOption.replace(/---/g, "-");
        colorOption = colorOption.toLowerCase();
        $(".js__color-swatches[data-type-value=" + colorOption + "]").removeClass("out-of-stock");
        $(".js__color-swatches[data-type-value=" + colorOption + "]").addClass("unavailable");

        if ($(".js__color-swatches[data-type-value=" + colorOption + "]").hasClass("active")) {
          var nextColor = colorCount + 1;

          if (colorCount < colorLength) {
            $(".js__color-swatches:nth-child(" + nextColor + ")").click();
          } else {
            $(".js__color-swatches:nth-child(1)").click();
          }
        }
      }

      colorCount++;
    });
  }

  function getColorPosition() {
    if (colorPosition != undefined && numberOfAvailableOptions > 1) {
      if (colorPosition == "1") {
        secondOptionVariantValue = $(".js__pdp-variant-select1").val();

        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $(".js__pdp-variant-select2").val();
        }
      }

      if (colorPosition == "2") {
        secondOptionVariantValue = $(".js__pdp-variant-select0").val();

        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $(".js__pdp-variant-select2").val();
        }
      }

      if (colorPosition == "3") {
        secondOptionVariantValue = $(".js__pdp-variant-select0").val();

        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $(".js__pdp-variant-select1").val();
        }
      }
    } else {
      secondOptionVariantValue = $(".js__pdp-variant-select0").val();

      if (numberOfAvailableOptions > 1) {
        thirdOptionVariantValue = $(".js__pdp-variant-select1").val();
      }
    }

    try {
      colorSelected = colorSelected.toLowerCase();
    } catch (_unused) {}
  }

  function setColorSwatchOutofStock(prodColor, prodQuantity, prodAvailability) {
    if (prodQuantity < 1 && prodAvailability == "false") {
      $(".js__color-swatches[data-type-value=" + prodColor + "]").addClass("out-of-stock");
    }
  }

  $(window).scroll(function () {
    var sticky = $(".product__media-outer"),
        scroll = $(window).scrollTop();
    var pos = sticky.height();

    if (scroll >= 768 & scroll <= pos - 690) {
      sticky.addClass("fixed"); // $(".main-content").addClass("active");
    } else {
      sticky.removeClass("fixed"); // $(".main-content").removeClass("active");
    }
  }); // show para on click read More button

  $(".js__read-more_btn").click(function () {
    $(".js__read-less-content").addClass("hide");
    $(".js__read-more-content").removeClass("hide");
  });
  $(".js__read-less_btn").click(function () {
    $(".js__read-less-content").removeClass("hide");
    $(".js__read-more-content").addClass("hide");
  });
});
$(document).ready(function ($) {
  $(document).on("click", ".js__product-you-may label", function (e) {
    var selectedVariantID = $(this).attr("data-variantID");
    var quantity = 1;
    var items = [];
    /* For the main item */

    items.push({
      id: selectedVariantID,
      quantity: quantity
    });
    CartJS.addItems(items, {
      success: function success(response, textStatus, jqXHR) {
        console.log(response); // console.log(CartJS.cart);

        $("#product-" + selectedVariantID).addClass("remove");
        var boolProductCount = false;
        $(".js__product-you-may").each(function () {
          if (!$(this).hasClass("remove")) {
            boolProductCount = true;
          }
        });

        if (boolProductCount == false) {
          $(".js__pdp-maylike-products-outer").hide();
        }

        if (getglobalLib("Mini_Cart") == "yes") {
          /* Show message */
          setTimeout(openMiniCart, 500);
        } else {
          window.location = "/cart";
        }
      },
      // Define an error callback to display an error message.
      error: function error(jqXHR, textStatus, errorThrown) {
        showCartErrorMessage();
      }
    });
  });
});
